import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { ButtonComponent } from '@components/button/button.component';
import { InfoCardComponent } from '@components/info-card/info-card.component';
import { SearchComponent } from '@components/search/search.component';
import { TableComponent } from '@components/table/table.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AccessTableComponent } from './access-table/access-table.component';

@NgModule({
  declarations: [
    SearchComponent,
    TableComponent,
    ButtonComponent,
    InfoCardComponent,
    AccessTableComponent,
  ],
  imports: [
    CommonModule,
    TabsModule.forRoot(),
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    RouterModule,
    FormsModule
  ],
  exports: [
    SearchComponent,
    TableComponent,
    ButtonComponent,
    InfoCardComponent,
    AccessTableComponent
  ]
})
export class UiComponentsModule { }
